import { useMutation } from '@tanstack/react-query'

import { fetchWithHeaders, getCSRFToken } from 'utils'
import { useWindowLocation } from 'utils/windowLocation'

import { GrapeAPIError, type GrapeAPIErrorType } from './GrapeAPIError'

export const useLogout = () => {
  const { reload } = useWindowLocation()

  return useMutation<void, GrapeAPIErrorType, void>({
    mutationFn: async () => {
      const response = await fetchWithHeaders('/sign_out', {
        method: 'DELETE',
        headers: {
          'X-CSRF-Token': getCSRFToken() || '',
        },
        credentials: 'same-origin'
      })

      if (!response.ok) {
        const errors = await response.json()
        throw GrapeAPIError({
          status: response.status,
          message: errors.message,
          errors: errors.errors,
          fieldErrors: errors.field_errors,
        })
      }
    },
    onSuccess: () => {
      // Reload the page after successful logout
      reload()
    }
  })
}
